<template>
  <div :class="clContainer()">
    <slot name="before"></slot>

    <span :class="clSub('label', 'label')" @click="toggle">{{ label }}</span>
    <img :class="clSub('check')" :src="checkboxImage" @click="toggle" />

    <slot name="after"></slot>

    <div :class="clSub('errors')">
      <div
        v-for="(error, index) in errors"
        :class="clSub('error')"
        :key="index"
      >
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
import Base from "./Base";
import NeedsIcons from "../../Mixins/NeedsIcons";

export default {
  extends: Base,
  mixins: [NeedsIcons],
  props: {
    typeClass: {
      type: String,
      default: "check",
    },
    imageChecked: {
      type: String,
      default: "checkbox-checked.svg",
    },
    imageUnchecked: {
      type: String,
      default: "checkbox-unchecked.svg",
    },
    imageDisabledChecked: {
      type: String,
      default: "checkbox-disabled-checked.svg",
    },
    imageDisabledUnchecked: {
      type: String,
      default: "checkbox-disabled-unchecked.svg",
    },
  },
  computed: {
    checkboxImage() {
      if (this.state == "edit") {
        return parseInt(this.data)
          ? this.getIconSrc(this.imageChecked)
          : this.getIconSrc(this.imageUnchecked);
      } else {
        return parseInt(this.data)
          ? this.getIconSrc(this.imageDisabledChecked)
          : this.getIconSrc(this.imageDisabledUnchecked);
      }
    },
  },
  methods: {
    toggle() {
      if (this.state == "edit") {
        this.data = parseInt(this.data) ? 0 : 1;
        this.dataChanged(true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.editable__element {
  &--edit &__check {
    cursor: pointer;
  }
}
</style>